import { styled } from 'styled-components';

export const CustomStyle = styled.div`
  .MODEL_SUGGEST_CLASS {
    color: #eb1616;
  }
`;
